import { Stack } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";

import ActionButton from "./cellActions/ActionButton";
import { ACCOUNT_STATUS } from "../../../models/Customer";

interface renderActionsCellContentProps {
  omneId: string;
  insuranceLinkedDate: string;
  omneName: string;
  accountStatus: string;
}

const renderActionsCellContent = ({
  omneId,
  insuranceLinkedDate,
  omneName,
  accountStatus,
}: renderActionsCellContentProps) => {
  const actions: string[] = [];
  if (insuranceLinkedDate) {
    actions.push("Unlink");
  }
  if (accountStatus !== ACCOUNT_STATUS.TOBEDELETED) {
    actions.push("Delete");
  }

  return (
    <Stack direction="row" spacing={1} alignItems={"center"}>
      {actions?.map(action => (
        <ActionButton
          key={`${omneId}-${action}`}
          action={action}
          omneId={omneId}
          omneName={omneName}
          customStyle={{
            height: 32,
            backgroundColor: "#E87722",
            color: "white",
          }}
        />
      ))}
    </Stack>
  );
};

const ActionsCell = (params: GridRenderCellParams) => {
  return renderActionsCellContent(params.value);
};

export default ActionsCell;
